import { stripHtml } from '~/utils/strip-html';

import { FaqMapperParams } from '../structuredMappers/faq';

export const rawToFaq = (data: {
  item: [
    {
      isFaq?: boolean;
      list: {
        accordionTitle: string;
        content: [{ content: string }];
      }[];
    }
  ];
}): FaqMapperParams | null =>
  data.item[0]?.isFaq
    ? {
        items: data.item[0].list.map((item) => ({
          title: item.accordionTitle,
          content: stripHtml(item.content[0].content),
        })),
      }
    : null;
